export default __webpack_public_path__ + "media/src/assets/images/Linehaul-4a893e512e0680198b5ae3ab44751c93.svg";